import {Component, inject, Input, OnInit} from '@angular/core';
import {Setting} from '../../../core/definitions/setting';
import {CommonsService} from '../../../core/commons.service';
import {CmsApiService} from '../../../core/cms-api.service';

@Component({
    selector: 'app-admin-settings-setting',
    templateUrl: './admin-settings-setting.component.html',
    styleUrls: ['./admin-settings-setting.component.scss'],
    standalone: false
})
export class AdminSettingsSettingComponent implements OnInit {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly commons: CommonsService = inject(CommonsService);

  @Input() setting: Setting;
  private origSetting: Setting;
  editing = false;
  error = '';
  storing = false;

  ngOnInit() {
    this.origSetting = this.commons.copy(this.setting);
  }

  editSetting() {
    this.editing = true;
  }

  storeSetting() {
    this.error = '';
    this.storing = true;
    this.cms.putSetting(this.setting).then(
      () => {
        this.editing = false;
        this.storing = false;
      },
      (reason) => {
        this.error = reason.error.message;
        this.storing = false;
      });
  }

  cancelSetting() {
    this.error = '';
    this.editing = false;
    this.setting = this.origSetting;
    this.origSetting = this.commons.copy(this.setting);
  }
}
